import styled from '@emotion/styled';
import { FormControlLabel } from '@mui/material';

export const Label = styled(FormControlLabel)`
  display: inline-flex;
  gap: 0.5rem;
  margin: 0;
`;
